import { MTDB_CONFIG } from './mtdb-config';
var ɵ0 = MTDB_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
